/**
 * Adapted from https://github.com/kentcdodds/use-deep-compare-effect to work
 * with our environment.
 */
import * as React from 'react';
import deepEqual from 'fast-deep-equal';
import { panic, readonlyArray } from '@code-expert/prelude';
const isProduction = process.env['NODE_ENV'] === 'production';
function isPrimitive(val) {
    return val == null || /^[sbn]/.test(typeof val);
}
function checkDeps(deps) {
    if (!deps || readonlyArray.isEmpty(deps)) {
        panic('useDeepCompareMemoize should not be used with no dependencies. Use React.useEffect instead.');
    }
    if (deps.every(isPrimitive)) {
        panic('useDeepCompareMemoize should not be used with dependencies that are all primitive values. Use React.useEffect instead.');
    }
}
export function useDeepCompareMemoize(value) {
    const ref = React.useRef(value);
    if (!deepEqual(value, ref.current)) {
        ref.current = value;
    }
    return ref.current;
}
export function useDeepCompareMemo(get, dependencies) {
    if (!isProduction) {
        checkDeps(dependencies);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return React.useMemo(get, useDeepCompareMemoize(dependencies));
}
export function useDeepCompareEffect(callback, dependencies) {
    if (!isProduction) {
        checkDeps(dependencies);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    React.useEffect(callback, useDeepCompareMemoize(dependencies));
}
//# sourceMappingURL=useDeepCompare.js.map